import {GET} from "@/services/gateway";

const getBackupsByDay = () => {
  return GET('dashboard/dropbox/backups')
}

export {
  getBackupsByDay,
}
